export const Data = [
  {
    question: `COVID-19 virus can be transmitted in areas with hot and humid climates?`,
    answer: `From the evidence so far, the COVID-19 virus can be transmitted in ALL AREAS, including areas with hot and humid weather. 
      Regardless of climate, adopt protective measures if you live in, or travel to an area reporting COVID-19. 
      The best way to protect yourself against COVID-19 is by frequently cleaning your hands. 
      By doing this you eliminate viruses that may be on your hands and avoid infection that could occur by then touching your eyes, mouth, and nose.`
  },
  {
    question: `Cold weather and snow CANNOT kill the new coronavirus?`,
    answer: `There is no reason to believe that cold weather can kill the new coronavirus or other diseases. 
      The normal human body temperature remains around 36.5°C to 37°C, regardless of the external temperature or weather. 
      The most effective way to protect yourself against the new coronavirus is by frequently cleaning your hands with alcohol-based hand rub or washing them with soap and water.`
  },
  {
    question: `Are there any specific medicines to prevent or treat the new coronavirus?`,
    answer: `To date, there is no specific medicine recommended to prevent or treat the new coronavirus (2019-nCoV).
      However, those infected with the virus should receive appropriate care to relieve and treat symptoms, 
      and those with severe illness should receive 
      optimized supportive care. Some specific
       treatments are under investigation, and will be tested through clinical trials. WHO is helping to accelerate research 
       and development efforts with a range of partners.`
  },
  {
    question: `Are hand dryers effective in killing the new coronavirus?`,
    answer: `No. Hand dryers are not effective in killing the 2019-nCoV. 
      To protect yourself against the new coronavirus, you should frequently clean your hands with an alcohol-based hand rub 
      or wash them with soap and water. 
      Once your hands are cleaned, you should dry them thoroughly by using paper towels or a warm air dryer.`
  },
  {
    question: `Do vaccines against pneumonia protect you against the new coronavirus?`,
    answer: `No. Vaccines against pneumonia, such as pneumococcal vaccine and Haemophilus influenza type B (Hib) vaccine, do not provide protection against the new coronavirus.
      The virus is so new and different that it needs its own vaccine. Researchers are trying to develop a vaccine against 2019-nCoV, and WHO is supporting their efforts.
      Although these vaccines are not effective against 2019-nCoV, vaccination against respiratory illnesses is highly recommended to protect your health.`
  },
  {
    question: `Can eating garlic help prevent infection with the new coronavirus?`,
    answer: `Garlic is a healthy food that may have some antimicrobial properties. However, 
      there is no evidence from the current outbreak that eating garlic has protected people from the new coronavirus.`
  },
  {
    question: `Are antibiotics effective in preventing and treating the new coronavirus?`,
    answer: `No, antibiotics do not work against viruses, only bacteria.
      The new coronavirus (2019-nCoV) is a virus and, therefore, antibiotics should not be used as a means of prevention or treatment.`
  }
];
